import { useLang, IMAGES } from "../../App";

export const TrustBand = () => {
  const { t } = useLang();
  return (
    <section className="relative py-20 border-b border-[#1e293b]/60 overflow-hidden" data-testid="trust-band">
      <div className="h-64 w-full relative overflow-hidden">
        <img src={IMAGES.band} alt="Kuala Lumpur financial district skyline at dusk" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#070d1e]/70"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#070d1e] via-transparent to-[#070d1e]"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 h-full flex flex-col justify-center text-center">
          <span className="mono text-xs uppercase tracking-[0.25em] text-[#fbbf24] mb-2">{t("band.eyebrow")}</span>
          <h2 className="disp text-3xl sm:text-4xl font-extrabold text-white">{t("band.title")}</h2>
          <p className="mono text-xs text-slate-400 mt-2" data-testid="band-contact">{t("band.contact")}</p>
        </div>
      </div>
    </section>
  );
};
